import React from "react";
import ButtonStyled from "./ButtonStyled";

type SubmitButtonProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isPending?: boolean;
  children?: React.ReactNode;
  extraClasses?: string;
  extraProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "solid" | "outline";
};

const SubmitButton = ({
  onClick,
  isPending = false,
  children,
  extraClasses = "",
  extraProps = {},
  type = "submit",
  disabled,
  variant = "solid",
}: SubmitButtonProps) => {
  return (
    <ButtonStyled
      onClick={onClick}
      isPending={isPending}
      disabled={disabled}
      type={type}
      variant={variant}
      className={extraClasses}
      extraProps={extraProps}
    >
      {children}
    </ButtonStyled>
  );
};

export default SubmitButton;
